import React from 'react';
import { PriceSuggestionReadonly } from './PriceSuggestionReadonly';
import { PriceSuggestionDynamic } from './PriceSuggestionDynamic';

export const PriceSuggestion = ({ quoteFormBodyData }) => {
  const { isReadOnly, isEdit } = quoteFormBodyData;
  if (isReadOnly || isEdit) {
    return <PriceSuggestionReadonly quoteFormBodyData={quoteFormBodyData} />;
  }

  return <PriceSuggestionDynamic quoteFormBodyData={quoteFormBodyData} />;
};
